/**
 * Turbo Downloader for Instagram — bulk media downloader
 *
 * Declares two WAR entries: one exposes six `icons/*` files (SVGs plus `igdl2.png`) to
 * every origin with no use_dynamic_url, the other scopes `js/options.js` and
 * `css/options.css` to instagram.com. The vendor-named `igdl2.png` icon is reachable from
 * any page at a fixed URL and loads through probeImage with no CORS grant.
 *
 * Manifest verified against version 4.12.16.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'cpgaheeihidjmolbakklolchdplenjai';

export const turboDownloaderForInstagram: ExtensionDefinition = {
  id: ID,
  name: 'Turbo Downloader for Instagram',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 600_000,
  notes:
    'Six icon files exposed to every origin with no dynamic URL (a second WAR entry is ' +
    'scoped to instagram.com). The vendor-named igdl2.png is conclusive and CORS-free.',
  signals: [
    {
      id: 'war-igdl2-png',
      kind: 'web-accessible-resource',
      description:
        'Load icons/igdl2.png via <img> — the vendor-named toolbar icon exposed to every ' +
        'origin; needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'icons/igdl2.png'),
    },
    {
      id: 'war-download-all-black-svg',
      kind: 'web-accessible-resource',
      description:
        'Load icons/download_all_black.svg via <img> — a second exposed icon, corroborating ' +
        'the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'icons/download_all_black.svg'),
    },
    {
      id: 'war-download-white-svg',
      kind: 'web-accessible-resource',
      description:
        'Load icons/download_white.svg via <img> — a third exposed icon, independent of the ' +
        'other two.',
      weight: 0.5,
      run: () => probeImage(ID, 'icons/download_white.svg'),
    },
  ],
};
